import Home from '@/views/boss/home/index'
import Login from '@/views/login/index'
import Group from '@/views/boss/group/index'
import User from '@/views/boss/user/index'
import Role from '@/views/boss/role/index'
import Resource from '@/views/boss/resource/index'
import ProjectConfig from '@/views/boss/project/index'
import Worker from '@/views/boss/worker/index'
import PushSwitch from '@/views/boss/parameters/pushswitch'
import GlConfig from '@/views/boss/template/glconfig'
import EquipmentLibrary from '@/views/boss/equipmentLibrary/index'
import VendorManagement from '@/views/boss/vendorManagement/index'
import DataPanelConfig from '@/views/boss/template/dataPanelConfig'
import GatewayConfiguration from '@/views/boss/gatewayConfiguration/index'
import ElectrovalenceConfiguration from '@/views/boss/electrovalenceConfiguration/index'
import ParallelBranch from '@/views/boss/parallelBranch/index'
import DeviceConfiguration from '@/views/boss/deviceConfiguration/index'
import DataDictionary from '@/views/boss/dataDictionary/index'
import TypicalParamConfiguration from '@/views/boss/typicalParamConfiguration/index'

/* svolt*/
import LayoutSvolt from '@/views/svolt/layout'
import HomeSvolt from '@/views/svolt/home/index'
import SvoltProject from '@/views/svolt/project/index'
/* 这个文件boss需要做下动态加载 */
export default [{
    path: '/user',
    name: 'User',
    component: User,
    meta: {
      title: '用户管理'
    }
  }, {
    path: '/role',
    name: 'Role',
    component: Role,
    meta: {
      title: '角色管理'
    }
  }, {
    path: '/resource',
    name: 'Resource',
    component: Resource,
    meta: {
      title: '资源管理'
    }
  }, {
    path: '/group',
    name: 'Group',
    component: Group,
    meta: {
      title: '组织配置'
    },
  },
  {
    path: '/projectconfig',
    name: 'ProjectConfig',
    component: ProjectConfig,
    meta: {
      title: '项目配置'
    }
  },
  {
    path: '/deviceConfiguration',
    name: 'DeviceConfiguration',
    component: DeviceConfiguration,
    meta: {
      title: '设备配置'
    }
  },
  {
    path: 'typicalParamConfiguration',
    name: 'TypicalParamConfiguration',
    component: TypicalParamConfiguration,
    meta: {
      title: '典型参数配置'
    }
  },
  {
    path: '/dataDictionary',
    name: 'DataDictionary',
    component: DataDictionary,
    meta: {
      title: '字典表'
    }
  },
  {
    path: '/parameters/pushswitch',
    name: 'PushSwitch',
    component: PushSwitch,
    meta: {
      title: '故障推送开关'
    }
  },
  {
    path: '/worker',
    name: 'Worker',
    component: Worker,
    meta: {
      title: '工单配置'
    }
  },
  {
    path: '/template/glconfig',
    name: 'GlConfig',
    component: GlConfig,
    meta: {
      title: '3D模型配置'
    }
  }, {
    path: '/equipmentLibrary',
    name: 'EquipmentLibrary',
    component: EquipmentLibrary,
    meta: {
      title: '设备库模块'
    }
  }, {
    path: '/vendorManagement',
    name: 'VendorManagement',
    component: VendorManagement,
    meta: {
      title: '厂商管理'
    }
  }, {
    path: '/template/dataPanelConfig',
    name: 'DataPanelConfig',
    component: DataPanelConfig,
    meta: {
      title: '数据面板配置'
    }
  }, {
    path: '/gatewayConfiguration',
    name: 'GatewayConfiguration',
    component: GatewayConfiguration,
    meta: {
      title: '网关配置'
    }
  }, {
    path: '/electrovalenceConfiguration',
    name: 'ElectrovalenceConfiguration',
    component: ElectrovalenceConfiguration,
    meta: {
      title: '电价配置'
    }
  }, {
    path: '/parallelBranch',
    name: 'ParallelBranch',
    component: ParallelBranch,
    meta: {
      title: '并网点清单'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/router.js